import { Injectable } from '@angular/core';
import { BaseService } from '../alcance/services/_base.service';

@Injectable({
  providedIn: 'root'
})
export class PrecoService extends BaseService {
    override classname: string = 'PrecoService';
    public override route: string = 'preco';
}
